<div class="gutter hidex flx-col flx-gap-default" *ngIf="!started">
	<header class="flx-col">
			<h4 i18n>Kariera</h4>
			<h2 i18n>Pracuj z nami!</h2>
	</header>
	<div class="hidex bgwhite flx-dynamic flx-cntr-cntr">
		<div class="w-100 flx-col flx-cntr-cntr">
				<div clas="flx-col flx-cntr-strt">
					<app-ve *ngIf="pageContent" [content]="pageContent"></app-ve>
					<button class="flat-button primary fat" (click)="startProcess()" i18n>Sprawdź kogo aktualnie poszukujemy</button>
				</div>
		</div>
	</div>
	<header class="flx-col">
		<h4>{{ pageName }}</h4>
		<h2 i18n>W liczbach</h2>
	</header>
	<div class="in_numbers_wrap gutter flx-row flx-wrap-grid flx-btwn-cntr">
		<div class="in_numbers">
			<div><span>500</span>
				<p i18n>liczba pracowników</p>
			</div>
		</div>
		<div class="in_numbers">
			<div><span>250</span>
				<p i18n>liczba punktów sprzedaży</p>
			</div>
		</div>
		<div class="in_numbers">
			<div><span>47</span>
				<p i18n>w tylu krajach są nasze produkty</p>
			</div>
		</div>
		<div class="in_numbers">
			<div><span>150</span>
				<p i18n>modeli w ofercie</p>
			</div>
		</div>
		<div class="in_numbers">
			<div><span>50000</span>
				<p i18n>przyczep rocznie</p>
			</div>
		</div>
	</div>
</div>


<section class="gutter reservation flx-col flx-cntr-cntr" *ngIf="form"> 

	<form [formGroup]="form" novalidate (submit)="submit()" class="steps w-100">
		<mat-vertical-stepper [linear]="isLinear" #stepper (selectionChange)="stepChange($event)">
			<mat-step id="step1" [completed]="selectedReservation">
				<ng-template matStepperIcon="edit" let-index="index">{{index +1}}</ng-template>
				<ng-template matStepperIcon="done"><svg class="icon icon-check"><use xlink:href="#icon-check"></use></svg></ng-template>
				<ng-template matStepLabel>
					<h3 i18n>Aktualnie poszukujemy</h3>
					<h4 *ngIf="selectedReservation"><ng-container i18n>Wybrałaś/eś:</ng-container> {{ selectedReservation.title }}</h4>
				</ng-template>

				<div class="flx-col flx-gap-default">

					<div *ngFor="let shop of reservationsSelected">
						<div class="offer flx-col flx-btwn-strtch">
							<div class="click-header flx-dynamic flx-gap-default flx-btwn-cntr" (click)="(active != shop.id ? active = shop.id : active = 0)">
								<h3>{{ shop.title }}</h3>
								<div class="flx-row flx-gap-default">
									<button type="button" class="stroked-button">
										<span *ngIf="active != shop.id" i18n>DOWIEDZ SIĘ WIĘCEJ</span>
										<span *ngIf="active == shop.id" i18n="@@close">ZAMKNIJ</span>
									</button>
								</div>
							</div>
							<div class="hidex" *ngIf="active == shop.id">
								<div class="offer-content">
									<div class="flx-dynamic flx-gap-default">
										<div class="w-33 flx-col" *ngIf="shop.description">
											<h4 i18n>Zakres obowiązków</h4>
											<p [innerHtml]="shop.description"></p>
										</div>
										<div class="w-33 flx-col" *ngIf="shop.extra_1">
											<h4 i18n>Wymagania</h4>
											<p [innerHtml]="shop.extra_1"></p>
										</div>
										<div class="w-33 flx-col" *ngIf="shop.extra_2">
											<h4 i18n>Oferujemy</h4>
											<p [innerHtml]="shop.extra_2"></p>
										</div>
									</div>
								</div>
								<div class="flx-row flx-cntr-cntr">
								<button type="button" class="flat-button primary fat" (click)="getAvailableDays(shop.id)" i18n>Jestem zainteresowany</button>
								</div>
							</div>
						</div>
					</div>
				</div>



			</mat-step>
			<mat-step id="step2" [stepControl] = "form">
				<ng-template matStepLabel><h3 i18n>Wprowadź swoje dane do kontaktu</h3></ng-template>
				
					<input type="hidden" formControlName="id_form">
					<div class="step-data flx-dynamic flx-gap-double">
						<div class="form-wrap" class="w-50">
							<h4 i18n>Uzupełnij formularz</h4>
							<mat-form-field appearance="outline" class="w-100">
								<mat-label i18n="@@namesurname">Imię i nazwisko</mat-label>
								<input matInput formControlName="name" i18n-placeholder>
								<mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
							</mat-form-field>
							<div class="flx-dynamic flx-gap-default flx-cntr-cntr">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label i18n="@@email">Adres e-mail</mat-label>
									<input matInput formControlName="email" i18n-placeholder>
									<mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
								</mat-form-field>
								<mat-form-field appearance="outline" class="w-100">
									<mat-label i18n="@@client_phone">Telefon</mat-label>
									<input matInput formControlName="phone" i18n-placeholder>
									<mat-error i18n *ngIf="form.get('country').value == 'PL'">To pole jest wymagane - format
										555444333</mat-error>
									<mat-error i18n *ngIf="form.get('country').value != 'PL'">To pole jest wymagane</mat-error>
								</mat-form-field>
								<!-- <mat-form-field appearance="outline" class="w-100">
									<mat-label i18n="@@country">Kraj pochodzenia</mat-label>
									<mat-select formControlName="country">
										<mat-option *ngFor="let country of countries" [value]="country.value">
											{{ country.viewValue }}
										</mat-option>
									</mat-select>
									<mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
								</mat-form-field> -->
							</div>
							<mat-form-field appearance="outline" class="w-100">
								<mat-label i18n>Dodatkowe uwagi?</mat-label>
								<textarea matInput formControlName="comment"></textarea>
							</mat-form-field>

							<div id="uploader" class="flx-row flx-gap-default flx-strt-strtch">

							<p class="infobox success" *ngIf="attachments.length > 0" i18n>Plik został dodany do Twojej wiadmości.</p>

							<div *ngIf="attachments.length == 0" ng2FileDrop [ngClass]="{'nv-file-over': hasBaseDropZoneOver}" (onFileDrop)="fileDropped($event)"  [uploader]="uploader" class="drop-zone">
								<mat-spinner *ngIf="loading_file" diameter="32" style="margin: 0 auto"></mat-spinner>
								<div *ngIf="!loading_file">
									<span i18n>DODAJ SWOJE CV PRZECIĄGAJĄC JE TUTAJ LUB </span> <label class="fileselect" for="file" i18n="@@selectdrv">WYBIERZ Z DYSKU</label><input id="file" class="inputfile" type="file" ng2FileSelect (onFileSelected)="fileDropped($event)" [uploader]="uploader" multiple>
								</div>
							</div>
							</div>

							<div class="rodo-checkbox w-100"
								[class.error]="form.controls.rodo.invalid && form.controls.rodo.dirty">
								<mat-checkbox formControlName="rodo" i18n>Wyrażam zgodę na przetwarzenie swoich danych osobowych.</mat-checkbox>
								<mat-error *ngIf="form.controls.rodo.invalid && form.controls.rodo.dirty" i18n>Musisz wyrazić
									zgodę na przetwarzenie swoich danych osobowych.</mat-error>
							</div>
							<p class="infobox error" *ngIf="res === 3" i18n>Zgłoszenie na podany adres email już istnieje - poczekaj na naszą odpowiedź, skontaktujemy się z Tobą najszybciej jak to będzie możliwe.</p>
							<p class="infobox error" *ngIf="res === 2" i18n>Coś się nie udało - spróbuj jeszcze raz.</p>
							<p class="infobox success" *ngIf="res === 1" i18n>Dziękujemy za rezerwację.</p>
							<button class="flat-button primary w-100 fat" type="submit" [disabled]="sent || res === 3" i18n>WYŚLIJ APLIKACJĘ</button>
						</div>
						<div class="clause-wrap"  class="w-50">
							<h4 i18n>W CV prosimy o dołączenie klauzuli zgody na przetwarzanie danych osobowych:</h4>
							<p #clause i18n>Wyrażam zgodę na przetwarzanie moich danych osobowych dla potrzeb niezbędnych do realizacji procesu rekrutacji (zgodnie z ustawą z dnia 10 maja 2018 roku o ochronie danych osobowych (Dz. Ustaw z 2018, poz. 1000) oraz zgodnie z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (RODO). Administratorem Twoich danych osobowych będzie Mantes Spółka z ograniczoną odpowiedzialnością siedzibą w Świdniku (Al. Kuźnicza 6-8, 21-040 Świdnik).</p><br>
							<button type="button" class="stroked-button w-100" (click)="copyInputMessage(clause)" i18n>Skopiuj klauzulę do schowka</button>
						</div>
					</div>
				
			</mat-step>
			<mat-step id="step3">
				<ng-template matStepLabel><h3 i18n>Podsumowanie</h3></ng-template>
				<div class="w-100 text-center gutter gutter-v" *ngIf="selectedReservation">
					<h1 i18n>Dziękujemy za aplikację.</h1>

					<div class="career-steps flx-col">
						<h3 i18n>Co dalej ?</h3>
						<ul class="w-100 flx-col flx-btwn-strtch">
							<li class="career-step">
								<span><ng-container i18n>Krok 1</ng-container><br><strong i18n>Spotykamy się na rozmowie</strong></span>
							</li>
							<li class="career-step">
								<span><ng-container i18n>Krok 2</ng-container><br><strong i18n>Otrzymujesz informację zwrotną (tak/nie)</strong></span>
							</li>
							<li class="career-step">
								<span><ng-container i18n>Krok 3</ng-container><br><strong i18n>Dołączasz do zespołu</strong></span>
							</li>
						</ul>
			
					</div>

				</div>
			</mat-step>
		
		</mat-vertical-stepper>
		</form>	




	<div class="regulations">
		{{ settings.extra_field_2 }} <span (click)="regulations = !regulations" i18n>...czytaj więcej</span>
		<div class="regulations-content" *ngIf="regulations" [innerHtml]="settings.extra_field_3">
		</div>
	</div>

</section>